import { tableResponsive } from "#scripts/table";
import { setImages } from "#scripts/images";
import {
	checkNested,
	setVariable,
	adjustVariables,
	urlParseCheck,
	checkDocument,
} from "#scripts/general_functions";
import { compileResources } from "#scripts/compile";
import { addSystemMessage } from "#scripts/dialog/dialog_messages";
import { setAccordian } from "#scripts/accordian";

export const getAimData = async (id) => {
	if (!id) {
		return;
	}
	const apiCall = `${window.apiUrl}/PublicContentApi/find/${id}`;
	try {
		// Fetch article and variables in parallel
		const [articleRes, variablesRes] = await Promise.all([
			fetch(apiCall),
			fetch("https://kariadmin.azurewebsites.net/api/clientvariables", {
				method: "POST",
				headers: { "Content-Type": "application/json-patch+json" },
				body: JSON.stringify({
					clientId: window.serverdata.configMeta.aim.servioId,
				}),
			}),
		]);

		if (!articleRes.ok || !variablesRes.ok) {
			parent.location = "/404";
			return;
		}

		const articleArr = await articleRes.json();
		const variablesArr = await variablesRes.json();

		const variables = adjustVariables(variablesArr);
		const allVariable = variables;

		if (checkNested(articleArr[0], "pageTypeId")) {
			if (articleArr[0].pageTypeId === "mal_artikkel") {
				parent.location = `/artikkel/${id}`;
				return;
			}
		} else {
			parent.location = "/404";
			return;
		}

		const removeExtraSpace = (_content) => {
			const regex = /<p>&nbsp;<\/p>|<p>/gi;
			return _content.replace(regex, "");
		};

		let content = decodeURIComponent(articleArr[0].contentObject);

		// Remove .var_text wrappers
		{
			const tempDiv = document.createElement("div");
			tempDiv.innerHTML = content;
			tempDiv.querySelectorAll(".var_text").forEach((el) => {
				while (el.firstChild) {
					el.parentNode.insertBefore(el.firstChild, el);
				}
				el.remove();
			});
			content = tempDiv.innerHTML;
		}

		const allRelateds = [];
		const pushRelatedContentObjects = (obj) => {
			if (obj.relatedContentObjects) {
				for (const relObj of obj.relatedContentObjects) {
					allRelateds.push(relObj);
					if (relObj.relatedContentObjects) {
						pushRelatedContentObjects(relObj);
					}
				}
			}
		};
		pushRelatedContentObjects(articleArr[0]);

		content = compileResources(content, articleArr[0].relatedContentObjects);
		content = removeExtraSpace(content);

		// tableResponsive expects a string and returns an element, so get innerHTML
		content = tableResponsive(content).innerHTML;
		content = setImages(content);
		content = setVariable(content, allVariable);
		content = setAccordian(content);
		content = urlParseCheck(content);
		content = checkDocument(content, allRelateds);

		if (articleArr[0].pageTypeId === "mal_blokk") {
			addSystemMessage(content);
		} else {
			window.location.href = `/artikkel/${id}`;
		}

		// Remove elements with class .removewhendone
		document.querySelectorAll(".removewhendone").forEach((el) => el.remove());

		// createGallery(); // Uncomment if needed
	} catch (err) {
		parent.location = "/404";
	}
};
